var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-flex',{staticClass:"myClass",attrs:{"fluid":""}},[_vm._v(" stuff ")])
}
var staticRenderFns = []

export { render, staticRenderFns }